import {
  getItem,
  setItem,
  removeItem,
} from './local-storage-utils';

const GLYMPSE_TOKEN_KEY = 'session.glympse.token';
const ACCESS_TOKEN = 'session.tracking.token';
const ACCESS_TOKEN_EXPIRATION = 'session.tracking.token_expiration';
const SESSION_HAS_EXPIRED = 'session.expired';

const AuthUtils = (() => {
  const getAuthToken = (): string => getItem(GLYMPSE_TOKEN_KEY);
  const setAuthToken = (authToken: string) => setItem(GLYMPSE_TOKEN_KEY, authToken);
  const removeAuthToken = () => removeItem(GLYMPSE_TOKEN_KEY);
  const getAccessToken = (): string => getItem(ACCESS_TOKEN);
  const setAccessToken = (accessToken: string) => setItem(ACCESS_TOKEN, accessToken);
  const removeAccessToken = () => removeItem(ACCESS_TOKEN);
  const getAccessTokenExp = (): string => getItem(ACCESS_TOKEN_EXPIRATION);
  const setAccessTokenExp = (expiration: string) => setItem(ACCESS_TOKEN_EXPIRATION, expiration);
  const removeAccessTokenExp = () => removeItem(ACCESS_TOKEN_EXPIRATION);
  const setSessionHasExpired = () => setItem(SESSION_HAS_EXPIRED, true);
  const removeSessionHasExpired = () => removeItem(SESSION_HAS_EXPIRED);
  const getSessionHasExpired = (): string => getItem(SESSION_HAS_EXPIRED);

  const isAuth = () => {
    const hasToken = !!getAccessToken();
    const expDate = new Date(Number(getAccessTokenExp()));
    const now = new Date();
    return hasToken && expDate > now;
  };

  const hasSessionExpired = (): boolean => {
    return !!getSessionHasExpired();
  };

  return {
    getAuthToken,
    setAuthToken,
    removeAuthToken,
    getAccessToken,
    setAccessToken,
    removeAccessToken,
    getAccessTokenExp,
    setAccessTokenExp,
    removeAccessTokenExp,
    setSessionHasExpired,
    removeSessionHasExpired,
    hasSessionExpired,
    isAuth,
  };
})();

export default AuthUtils;
